import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../../configs/AppConfig";
import {AUTH_TIPE} from "../../constants/AuthConstant";

const kodeOKService = {}

kodeOKService.data = function (token,data='') {
    return fetch({
        url: '/helpers/get_kode_ok',
        method: 'get',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

export default kodeOKService;
